import PropTypes from 'prop-types';
import React from 'react';
import Block from '../../../components/generic/Block';
import BlockImg from '../../../components/generic/BlockImg';
import Flex from '../../../components/generic/Flex';
import Text from '../../../components/generic/Text';
import Link from '../../../components/Link';
import WasteTypeId from '../../../constants/enums/WasteTypeId';
import { fontFamily } from '../../../constants/font';

const CollectionPointPopup = ({ name, location, phone, openingHours, webPage, description, wasteBinsCodesOb, wasteBins }) => {
  const parsedWasteBinsCodesOb = JSON.parse(wasteBinsCodesOb);
  const wasteBinsCodes = Object.values(parsedWasteBinsCodesOb);
  const isGabaryt = wasteBinsCodes.length === 1 && wasteBinsCodes[0] === WasteTypeId.gabaryt;

  return (
    <Block minWidth={30} maxWidth={60} style={{ fontFamily }}>
      <Text bold marginBottom={2} paddingRight={2}>
        {isGabaryt ? 'Kontener wielkogabarytowy' : name}
      </Text>
      {location && <Text marginBottom={2}>{location}</Text>}
      {phone && <Text marginBottom={2}>{phone}</Text>}
      {openingHours && <Text marginBottom={2} style={{ whiteSpace: 'pre-wrap' }}>{openingHours}</Text>}
      {webPage && <Link external href={webPage} marginBottom={2} style={{ overflowWrap: 'break-word' }}>{webPage}</Link>}
      {isGabaryt && <Text style={{ whiteSpace: 'pre-wrap' }} marginBottom={2}>{description}</Text>}
      <Flex flexWrap>
        {wasteBinsCodes.map((wasteBinCode) => {
          const wasteType = wasteBins[wasteBinCode];
          return (
            <BlockImg
              key={wasteBinCode}
              src={wasteType.icon}
              alt={wasteType.name}
              title={wasteType.name}
              width={8}
              height={8}
              marginRight={2}
              marginBottom={2}
            />
          );
        })}
      </Flex>
    </Block>
  );
};
CollectionPointPopup.propTypes = {
  name: PropTypes.string,
  location: PropTypes.string,
  phone: PropTypes.string,
  openingHours: PropTypes.string,
  webPage: PropTypes.string,
  description: PropTypes.string,
  wasteBinsCodesOb: PropTypes.string.isRequired,
  wasteBins: PropTypes.object.isRequired,
};

export default CollectionPointPopup;
